// extracted by css-extract-rspack-plugin
export default {"solid":"EntryStatusLabel-module__solid__tJ_QL"};